'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("aadService", function ($modal, $http, $dialogBox, $q) {
  return {
    /**
     *
     * @param $scope
     * @param aadId id de l'aad
     * @returns {*}
     */
    openEditionPopin: function openEditionPopin($scope, aadId) {
      return $modal.open({
        scope: $scope,
        controller: "AadCompteEditionPopinController",
        template: require("./edition/aadCompteEditionPopin.html"),
        vars: {
          edit: aadId != null,
          aadId: aadId
        },
        options: {
          width: 750
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/aad/aadService.js
// module id = 2675
// module chunks = 13